import { render, staticRenderFns } from "./businessOwnerOrders.vue?vue&type=template&id=3e96624a&scoped=true"
import script from "./businessOwnerOrders.vue?vue&type=script&lang=js"
export * from "./businessOwnerOrders.vue?vue&type=script&lang=js"
import style0 from "./businessOwnerOrders.vue?vue&type=style&index=0&id=3e96624a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96624a",
  null
  
)

export default component.exports